import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResult, JsonServiceClient } from '@servicestack/client';
import { AuthService } from 'libs/auth/src/lib/auth.service';
/* import { GetKullaniciBilgi_Request, GetKullaniciBilgi_Response, GetPersonelBilgi_Request, GetPersonelBilgi_Response } from '../models/ortak.dtos';
 */ import { map, Observable } from 'rxjs';
import { environment } from './app-settings.service';
import {
  GetKullaniciBilgi_Request,
  GetKullaniciBilgi_Response,
  GetPersonelBilgi_Request,
  GetPersonelBilgi_Response,
} from '../models/ortak.dtos';

@Injectable({
  providedIn: 'root',
})
export class UserInformationService {
  private client = new JsonServiceClient(environment.ortakService);

    constructor(
      private authService: AuthService,
    ) {
      const accessToken = this.authService.loggedUser?.access_token;
      const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      };
      this.client.headers.append('Content-Type', headers['Content-Type']);
      this.client.headers.append('Authorization', headers['Authorization']);
    }



  async getUserInfoWithToken(): Promise<ApiResult<GetKullaniciBilgi_Response>> {

    const api = await this.client.api(
      new GetKullaniciBilgi_Request({
        //...
      })
    );

    return api;
  }

  async getPersonelInfo(): Promise<ApiResult<GetPersonelBilgi_Response>> {
    const api = await this.client.api(
      new GetPersonelBilgi_Request({
        //...
      })
    );

    return api;
  }

}
